// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "add-2nN4L";
var _3 = "header-2LjRP";
var _4 = "totalPrice-7_sjJ";
var _5 = "aggregator_animal-2_z_N";
var _6 = "cover-eKVJd";
var _7 = "aggregator_baggageDelivery-1TFAy";
var _8 = "aggregator_business-3tZUG";
var _9 = "aggregator_loyalty-3-Vt8";
var _a = "icons-1Tsp4";
var _b = "loyalty_aggregator-1buxH";
var _c = "container-3dXWy";
var _d = "container_active-1z6lC";
var _e = "button-2hSRj";
var _f = "button_add-2icWH";
export { _1 as "__esModule", _2 as "add", _3 as "header", _4 as "totalPrice", _5 as "aggregator_animal", _6 as "cover", _7 as "aggregator_baggageDelivery", _8 as "aggregator_business", _9 as "aggregator_loyalty", _a as "icons", _b as "loyalty_aggregator", _c as "container", _d as "container_active", _e as "button", _f as "button_add" }
export default { "__esModule": _1, "add": _2, "header": _3, "totalPrice": _4, "aggregator_animal": _5, "cover": _6, "aggregator_baggageDelivery": _7, "aggregator_business": _8, "aggregator_loyalty": _9, "icons": _a, "loyalty_aggregator": _b, "container": _c, "container_active": _d, "button": _e, "button_add": _f }
